import { atom } from 'recoil';

const loadingOverlayAtom = atom<{
  isOpen: boolean;
}>({
  key: 'loadingOverlayAtom',
  default: { isOpen: false }
});

export { loadingOverlayAtom };
